import Carriers from './carrier-items-list-screen.vue';

export default {
    components: {
        'carriers': Carriers
    },

    data: function () {
        return {
            loading: false,
            appId: this.$route.params.id ?? 0,
            senderId: this.$route.params.senderId ?? 0,
            model: this.emptyModel(),
        }
    },

    computed: {

    },

    methods: {
        refreshScreen() {
            this.appId = this.$route.params.id ?? 0;
            this.senderId = this.$route.params.senderId ?? 0;
            this.onLoadModelDataSource();
        },

        emptyModel() {
            return {
                AppId: 0,
                SenderId: 0,
                SenderName: '',
                SenderCode: 0
            }
        },

        async onLoadModelDataSource() {
            try {
                this.loading = true;

                let url = '/api/ui/carrier_applications/load/' + this.appId + '/' + this.senderId;
                let response = await this.$http.get(url);
                this.model = response.body;

                this.$refs.carriers.channelSettings = {
                    SenderId: this.model.SenderId,
                    SenderName: this.model.SenderName,
                    SenderCode: this.model.SenderCode
                }
            }
            catch (ex) {
                this.$processException(ex);
            }
            finally {
                this.loading = false;
            }
        },
    },

    watch: {
        // Reload data if the route changed manually from browser address bar
        $route: 'refreshScreen'
    },

    mounted: function () {
        this.refreshScreen();
    }
}